<template>
  <div>
    <category-layout>
      <section class="about-item-area">
        <div class="container">
          <div class="bg-white pt-20 pb-20">
            <div class="row">
              <div class="col-md-12 left-sidebar mb-20">
                <!-- 添加容器包裹图片和菜单 -->
                <div class="menu-container">
                  <img src="@/assets/images/page/tab.png" alt="" class="menu-image" />
                  <el-menu 
                    :default-active="activeMenu" 
                    mode="vertical"
                    background-color="#f5f7fa"
                    text-color="#303133"
                    active-text-color="#409EFF"
                    @select="handleSelect"
                    class="menu-width"
                    >
                    <el-menu-item index="1">全部期刊</el-menu-item>
                    <el-menu-item index="2">核心期刊</el-menu-item>
                    <el-menu-item index="3">普通期刊</el-menu-item>
                  </el-menu>
                </div>
              </div>

              <div class="col-md-12 right-content">
                <div class="search-container">
                  <div class="search-header-bg"></div>
                  <div class="search-row">
                    <!-- 关键字搜索区域包裹 -->
                    <div class="search-group">
                      <span class="search-label pl-20 pr-20">关键字</span>
                      <el-input 
                        placeholder="请输入搜索关键字" 
                        v-model="searchKeyword" 
                        class="search-input"
                        @keyup.enter.native="handleSearch"
                      >
                      </el-input>
                    </div>

                    <el-button 
                      type="primary" 
                      class="search-button" 
                      @click="handleSearch"
                      icon="el-icon-search"
                    >查询</el-button>
                  </div>
                </div>               

                <div class="about-tab-btn">
                  <div class="about-post-items">
                    <div class="row" v-if="journals.length">
                      <template v-for="(small, index) in journals">
                        <div class="col-md-3" :key="index">
                          <div class="feature-news-item cursor-pointer" 
                            @click="handleJournalClick(small)"
                          >
                            <div class="feature-news-thumb">
                              <img :src="small.coverurl" :alt="small.title" class="magazine-img">
                            </div>
                            <div class="feature-news-content">
                              <p>{{ small.title }}</p>
                              <p>{{ small.abbreviation }}</p>
                            </div>
                          </div>
                        </div>
                      </template>

                      <div class="col-lg-12">
                        <div v-if="totalPages > 1" class="pagination-item">
                          <nav aria-label="Page navigation example">
                            <ul class="pagination">
                              <!-- 上一页按钮 -->
                              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                <a class="page-link" @click="changePage(currentPage - 1)" href="#" aria-label="Previous">
                                  <span aria-hidden="true"><i class="fas fa-caret-left"></i></span>
                                </a>
                              </li>
                              <!-- 页码按钮 -->
                              <li 
                                v-for="page in visiblePages" 
                                :key="page" 
                                class="page-item" 
                                :class="{ active: page === currentPage }"
                              >
                                <a class="page-link" @click="changePage(page)" href="#">{{ page }}</a>
                              </li>
                              <!-- 下一页按钮 -->
                              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                <a class="page-link" @click="changePage(currentPage + 1)" href="#" aria-label="Next">
                                  <span aria-hidden="true"><i class="fas fa-caret-right"></i></span>
                                </a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-else>
                      <div class="col-lg-12">
                        <div class="error-thumb text-center">
                          <img src="@/assets/images/empty.jpg" alt="" />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </category-layout>
  </div>
</template>

<script>
import CategoryLayout from "@/components/Events/CategoryLayout.vue";
import Posts from "../Data/TrendingHomeThree";
import { getJournals } from "@/api/journal";

export default {
  components: { CategoryLayout },
  // 将箭头函数改为普通函数，确保this指向Vue实例
  data() {
    return {
      posts: Posts.data,
      activeMenu: '1',
      searchKeyword: '',
      journals: [],
      keyword: this.$route.query.keyword || '',    
      // 每页显示的文章数量
      pageSize: 12,
      // 当前页码
      currentPage: 1,
      // 总文章数量
      total: 0,
      // 最多显示的页码数
      maxVisiblePages: 5
    }
  },
  created() {
    this.fetchJournals();
  },
  computed: {
    // 计算总页数
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },
    // 计算可见的页码
    visiblePages() {
      const startPage = Math.max(1, this.currentPage - Math.floor(this.maxVisiblePages / 2));
      const endPage = Math.min(this.totalPages, startPage + this.maxVisiblePages - 1);
      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    }
  },
  methods: {
    async fetchJournals() {
      try {
        const filter = {};
        if (this.channel) {
          filter.channel = this.channel;
        }
        if (this.keyword) {
          filter.keyword = this.keyword;
        }
        // 新增：添加状态过滤条件
        if (this.selectedStatus) {
          filter.status = this.selectedStatus;
        }
        const response = await getJournals({
          filter,
        },(this.currentPage - 1) * this.pageSize, this.pageSize);
        if (response && response.list) {
          this.journals = response.list;

          this.total = response.data.pagination.total;
        } else {
          console.error('响应数据格式不正确');
        }
      } catch (error) {
        console.error('获取文章数据失败:', error);
      }
    },
    // 切换页码的方法
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchJournals();
      }
    },
    // 重置分页信息
    resetPagination() {
      this.currentPage = 1;
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        // 这里可以根据需要实现搜索逻辑
        // 例如：this.keyword = this.searchKeyword;
      }
    },
    handleSelect(key) {
      this.activeMenu = key; 
    },
    handleJournalClick(journal) {
      this.$router.push({ 
        name: 'JournalDetail', 
        params: { id: journal.id } 
      });
    },
  },
};
</script>

<style scoped>
.three-line-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 显示三行 */
}

/* 添加菜单宽度控制样式 */
.menu-container {
  display: inline-block;
  width: fit-content;
}

.menu-image {
  width: 100%;
  height: auto;
}

.menu-width {
  width: 100%;
  border: none; /* 可选：移除默认边框 */
  margin-top: 5px;
}

/* 新增：菜单选中状态样式 */
::v-deep .el-menu-item.is-active {
  background-image: url('~@/assets/images/page/tab_bg.png'); /* 添加~前缀修复路径解析问题 */
  background-size: cover;
  background-repeat: no-repeat;
  color: #ffffff !important;
}

/* 搜索区域样式 */
/* 修改搜索容器样式，添加背景图 */
.search-container {
  width: 100%;
  background-color: #eff0f2; /* 设置背景色 */
  padding: 0; /* 移除内边距，避免影响图片显示 */
}

/* 新增：搜索区域头部图片样式 */
.search-header-img {
  width: 100%; /* 宽度与搜索区域一致 */
  height: auto;
  display: block; /* 确保图片正确显示 */
}

/* 搜索按钮样式 */
.search-button {
  margin-left: 10px;
  min-width: 80px;
}

/* 调整搜索行样式，确保元素正确排列 */
.search-row {
  display: flex;
  gap: 10px;
  padding: 10px;
  align-items: center;
  flex-wrap: nowrap; /* 防止元素换行 */
}

/* 调整搜索行样式，添加内边距 */
.search-row {
  display: flex;
  gap: 10px;
  padding: 10px; /* 原有内边距移至此处 */
  align-items: center;
}

/* 新增：搜索标签样式 */
.search-label {
  white-space: nowrap;
  color: #303133;
  font-size: 14px;
}

.search-select {
  flex: 1;
}

.search-input {
  flex: 2;
}

/* 新增：搜索区域顶部背景样式 */
.search-header-bg {
  height: 8px;
  width: 100%;
  background-image: url('~@/assets/images/page/header_bg.png');
  background-repeat: repeat-x; /* 水平重复显示 */
  background-size: auto 100%; /* 保持图片原有宽度，高度适应容器 */
}

/* 自定义左侧区域宽度 - 在大屏幕下生效 */
@media (min-width: 992px) {
  .left-sidebar {
    flex: 0 0 22%; /* 可根据需要调整此百分比（建议20%-24%之间） */
    max-width: 22%;
  }
  .right-content {
    flex: 0 0 78%; /* 右侧宽度自动适配（100% - 左侧宽度） */
    max-width: 78%;
  }
}

/* 修改移动端搜索区域适配 */
@media (max-width: 768px) {
  /* 允许搜索元素换行 - 修改为块级显示 */
  .search-row {
    display: block; /* 将flex改为block */
    padding: 15px 10px;
  }
  
  /* 修改搜索组容器 - 实现各占一列布局 */
  .search-group {
    width: 100%; /* 每个搜索组占满整行 */
    margin-bottom: 15px; /* 增加组之间的垂直间距 */
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }
  
  /* 搜索标签样式 */
  .search-group .search-label {
    flex: 0 0 auto;
    text-align: left;
    padding-right: 0;
    white-space: nowrap;
  }
  
  .search-select, .search-input {
    flex: 1;
    min-width: 0;
  }
  
  /* 搜索按钮在移动端占满整行 */
  .search-button {
    width: 100%;
    margin-left: 0;
    padding: 12px 0;
  }
  
  /* 调整搜索容器边距 */
  .search-container {
    margin-bottom: 20px; /* 减少底部间距 */
  }
}

/* 调整搜索组样式，确保标签和输入框在同一行 */
.search-group {
  flex: 1; /* 让搜索组在搜索行中分配空间 */
  display: flex;
  align-items: center;
  gap: 8px; /* 标签和输入框间距 */
}

/* 搜索标签样式优化 */
.search-label {
  white-space: nowrap;
  color: #303133;
  font-size: 14px;
  flex: 0 0 auto; /* 标签不伸缩 */
}

/* 搜索输入框样式调整 */
.search-input {
  flex: 1; /* 输入框占据剩余空间 */
}

/* 搜索选择框样式调整 */
.search-select {
  flex: 1; /* 选择框占据剩余空间 */
}
</style>